import ReactDOM from 'react-dom';

function createContainer() {
    // 创建一个 Modal 的容器
  const layerContainer = document.createElement('div');
    // 插入到 body 中
  document.body.appendChild(layerContainer);

  return layerContainer;
}

function removeContainer(layerContainer) {
  // 从 DOM 中删除弹出层组件
  const unmounted = ReactDOM.unmountComponentAtNode(layerContainer);
  if (unmounted) document.body.removeChild(layerContainer);
}

export { createContainer, removeContainer };
